import React from 'react';
import {classNames} from "../../../utils/common";

const AmountField = ({label, currency, amount, setAmount, smallerSize = false, withLabel = true, ...props}) => {
    return (
        <div className={classNames(smallerSize ? undefined : "mt-5 mx-8")} {...props}>
            {withLabel && label && (
                <label htmlFor="amount" className={classNames(
                    smallerSize ? "ml-1 text-xs" : "ml-3 text-sm",
                    "block font-medium text-gray-700"
                )}>{label}</label>
            )}
            <div className={classNames(
                smallerSize ? "mt-0.5 h-7" : "mt-1 h-10",
                "relative rounded-md shadow-sm"
            )}>
                <div className={classNames(
                    smallerSize ? "pl-1.5" : "pl-3",
                    "absolute inset-y-0 left-0 flex items-center pointer-events-none"
                )}>
                    {currency && <span className={classNames(
                        smallerSize ? "text-xs" : "sm:text-sm",
                        "text-gray-500"
                    )}>{currency.symbol}</span>}
                </div>
                <input
                    value={amount}
                    onChange={(event) => setAmount(event.target.value)}
                    type="text"
                    id="amount"
                    placeholder="0.00"
                    className={classNames(
                        smallerSize
                            ? "h-7 w-28 pl-5 pr-8 text-xs"
                            : "h-10 w-40 pl-8 pr-12 sm:text-sm",
                        "focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 rounded-md"
                    )}
                />
                <div className={classNames(
                    smallerSize ? "pr-1.5" : "pr-3",
                    "absolute inset-y-0 right-0 flex items-center pointer-events-none"
                )}>
                    {currency && <span className={classNames(
                        smallerSize ? "text-xs" : "sm:text-sm",
                        "text-gray-500"
                    )}>{currency.code}</span>}
                </div>
            </div>
        </div>
    );
};

export default AmountField;
